export function queryStringify(
    query: Record<string, string> = {},
    prefix: string = '',
) {
    const pairs: string[] = [];
    for (const key in query) {
        if (Object.prototype.hasOwnProperty.call(query, key)) {
            let value = query[key];
            if (
                !value &&
                (value === null || value === undefined || Number.isNaN(value))
            ) {
                value = '';
            }

            pairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
